<template>
  <!--//@*/*
      //    *RPD  App v0.91
      //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
      //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
      //    */
      //-->
  <div id="init-home-container" class="d-flex background_color">
    <v-container class="background_color black--text" id="home-container">
      <template>
        <div class="bcs-expansion-content mt-4">
          <div
            id="big-card"
            class="d-flex justify-center align-center background_color"
          >
            <v-card
              id="home-content-area"
              class="mb-16 pt-4"
              color="grey lighten-5"
              elevation="4"
              outlined
            >
              <div class="bcs-expansion-content mt-4">
                <v-card elevation="2" shaped class="basic-interior-card pa-4">
                  <p class="mt-4 text-h6 text-sm-h4 text-center">
                    DOCUMENT RETRIEVAL GUIDE
                  </p>
                </v-card>

                <v-card elevation="2" shaped class="basic-interior-card pa-4">
                  <p class="mt-4">
                    Once the request has been fulfilled, the customer will
                    receive another email stating they can click the link to
                    retrieve their request.
                  </p>
                  <div>
                    <div
                      class="d-flex row justify-center pa-1 div-login-page-img"
                    >
                      <!-- <v-img
                class="elevation-3 pa-1 letter2_img"
                src="../images/ltr_completed_600.png"
              ></v-img> -->
                      <div class="d-flex d-sm-none elevation-3">
                        <img
                          class="pa-1 letter2_img"
                          src="../images/ltr_completed_600.png"
                        />
                      </div>
                      <div class="d-none d-sm-flex elevation-3">
                        <v-img src="../images/ltr_completed_960.png"></v-img>
                      </div>
                    </div>
                  </div>
                </v-card>
                <v-card
                  elevation="2"
                  shaped
                  class="basic-interior-card mt-8 pa-4"
                >
                  <h3>
                    Clicking on the link in the email brings the customer to the
                    login page.
                  </h3>
                  <div
                    class="d-flex row justify-center mt-2 pa-4 div-login-page-img elevation-3"
                  >
                    <v-img
                      class="login-page-img"
                      src="../images/loginpage.png"
                    ></v-img>
                  </div>
                </v-card>
                <v-card shaped>
                  <p class="mt-4">
                    Upon logging in, they are directed to that specific request
                    which will show a status of 'completed'.
                  </p>
                  <div class="mt-2 pa-4">
                    <div class="d-flex d-sm-none elevation-3">
                      <v-img
                        src="../images/public_request_geninfo_mobile_600.png"
                      ></v-img>
                    </div>
                    <div class="d-none d-sm-flex elevation-3">
                      <img
                        class="pa-1 img_100_per"
                        src="../images/public_request_geninfo_960.png"
                      />
                    </div>
                  </div>
                </v-card>
                <v-card shaped>
                  <div class="mt-4">
                    <p class="mt-4">
                      Customer should then click on 'Public Records'
                    </p>
                    <div class="d-flex d-sm-none pa-1">
                      <v-img
                        src="../images/clic_pub_rec_mobile_600.png"
                      ></v-img>
                    </div>
                    <div class="d-none d-sm-flex elevation-3">
                      <img
                        class="pa-1 img_100_per"
                        src="../images/clic_pub_rec_960.png"
                      />
                    </div>
                    <p class="mt-4">
                      which will show them the documents that have been released
                      (Test - copy of a report).
                    </p>
                  </div>
                </v-card>
                <v-card shaped>
                  <p class="mt-4">
                    Clicking on the pencil will further open the request where
                    they will have a download icon. Clicking on the download
                    icon will download the document(s) that have been released.
                  </p>
                  <div class="mt-2 pa-4">
                    <div class="d-flex d-sm-none elevation-3">
                      <v-img
                        src="../images/pub_rec_deets_mobile_600.png"
                      ></v-img>
                    </div>
                    <div class="d-none d-sm-flex elevation-3">
                      <img
                        class="pa-1 img_100_per"
                        src="../images/pub_rec_deets_960.png"
                      />
                    </div>
                  </div>
                </v-card>

                <v-card>
                  <p class="mt-4">
                    Once they have retrieved the documents, they can click
                    'home' to return to their main page where it will show all
                    requests that they have submitted with the status of each
                    request.
                  </p>
                  <div class="mt-2 pa-4">
                    <div class="d-flex d-sm-none elevation-3">
                      <img
                        class="pa-1 login-page-img"
                        src="../images/pub_rec_home_final_mobile_600.png"
                      />
                    </div>
                    <div class="d-none d-sm-flex elevation-3">
                      <v-img src="../images/pub_rec_home_final_960.png"></v-img>
                    </div>
                  </div>
                </v-card>
              </div>
            </v-card>
          </div>
        </div>
      </template>
    </v-container>
    <v-btn
      @click.prevent="fabup"
      class="fabup"
      elevation="2"
      fab
      color="green"
      title="back"
    >
      <v-icon color="black" dark> $arrowLeft </v-icon>
    </v-btn>
  </div>
</template>
<style scoped>
.fabup {
  position: fixed;
  left: 85%;
  top: 90%;
  z-index: 500;
}
.letter2_img {
  /* max-width: 877px; */
  width: 100%;
  height: auto;
}
p {
  font-weight: 600;
  padding: 12px;
}
a {
  color: blue;
}
a:visited {
  color: rgb(2, 2, 32);
}
.bcs-expansion-content {
  color: black;
}
.bcs-expansion-content {
  color: black;
}
.basic-interior-card {
  min-height: 100px;
  margin: 8px;
}
.div-login-page-img {
  margin: 0;
}
.login-page-img {
  width: 100%;
  height: auto;
  margin-left: 0 !important;
}
@media (min-width: 768px) {
  .fabup {
    position: fixed;
    left: 96%;
    top: 90%;
  }
  #home-container {
    width: 100vw;

    height: auto;
    position: relative;
    top: 0px;
  }
  .login-page-img {
    max-width: 300px;
  }
  .letter2_img {
    /* max-width: 877px; */
    width: 80%;
    height: auto;
  }
  .img_100_per {
    /* max-width: 877px; */
    width: 100%;
    height: auto;
  }
}
</style>
<script>
import { bus_common } from "../mixins/bus_common";
export default {
  name: "doc_ret_guide",
  mixins: [bus_common],
  data: function () {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    fabup() {
      history.back();
    },
    onExpansionPanelClick(event) {
      this.$emit("onExpansionPanelClick", event);
    },
    init: function () {
      this.show_loader(false);
      var element = document.getElementById("vapp");
      element.style.maxHeight = "650vh";
      element.style.height = "650vh";
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
      // The whole view is rendered, so I can safely access or query
      // the DOM. ¯\_(ツ)_/¯
    });
  },
};
</script>
